Ellipsis(); //default conf
